import { http, URL } from "./http.service";

// Get business by slug/name
export const getBusinessBySlug = async (slug) => {
    const url = `${URL}/business/by-slug/${slug}`;
    return await http.get(url);
};

// Get business by UUID
export const getBusinessByUuid = async (uuid) => {
    const url = `${URL}/business/${uuid}`;
    return await http.get(url);
};

// Validate if business exists
export const validateBusiness = async (identifier) => {
    // Check if identifier is UUID or slug
    const isUuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(identifier);
    
    if (isUuid) {
        return await getBusinessByUuid(identifier);
    } else {
        return await getBusinessBySlug(identifier);
    }
};